/* eslint-disable */
import * as React from "react";
import { last, first } from "lodash";
import { ReportToolbar, ReportToolbarGroup, ReportToolbarSpacer, ReportToolbarNumber } from "../../components/ReportToolbar";
import { ReportGrid } from "../../components/ReportGrid";
import { ReportLayout } from "../../components/ReportLayout";
import { ReportHeader } from "../../components/ReportHeader";
import { ReportContainer } from "../../components/ReportContainer";
import { ReportRenderer, useParameter } from "../../shared";
import { CommoditiesControl } from "./controls/CommoditiesControl";
import { UnitsControl } from "./controls/UnitsControl";
import { FrequencyControl } from "./controls/FrequencyControl";
import { StartDateControl } from "./controls/StartDateControl";
import { EndDateControl } from "./controls/EndDateControl";

import { useExportQuery } from "./export/useExportQuery";
import { useFavourite } from "./favourite/useFavourite";
import { useSubscription } from "./subscription/useSubscription";
import { useSlideTitle } from "./hooks/useSlideTitle";
import { useSlideSubtitle } from "./hooks/useSlideSubtitle";
import { SLIDE_NUMBER } from "./constants";

export default function Slide32(props: { exportMode?: boolean }) {
  const { exportMode } = props;
  const [commodity] = useParameter<number>("@commodities");
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const { isFavouriteLoading } = useFavourite();
  useSubscription();

  return (
    <ReportContainer>
      <ReportHeader title={title} subtitle={subtitle} exportMode={exportMode} />
      <ReportToolbar exportMode={exportMode}>
        <ReportToolbarGroup isLoading={isFavouriteLoading}>
          <CommoditiesControl />
          <UnitsControl key={commodity || undefined} />
          <FrequencyControl />
          <StartDateControl />
          <EndDateControl />
        </ReportToolbarGroup>
        <ReportToolbarSpacer />
        <ReportToolbarNumber number={SLIDE_NUMBER} />
      </ReportToolbar>
      <ReportLayout>
        <ReportGrid>
          <ReportRenderer componentId="chart-growth" />
          <ReportRenderer componentId="chart-historical" />
        </ReportGrid>
      </ReportLayout>
    </ReportContainer>
  );
}
